import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ExportOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Modal, DatePicker, Tooltip, Button, Avatar } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import WorkReportForm from './WorkReportForm';
import Detail from './Detail';
import { checkPermission } from '@/utils/permission';
import { cleanObject, getFirstLetterOfWords, isValidDate, stripHtml } from '@/utils/helpers';
import TextTruncate from 'react-text-truncate';
import BaseSelect from '@/components/Elements/BaseSelect';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import { getAllData, getData, removeData, exportExcel } from '@/redux/actions/WorkReportActions';
import { NotificationManager } from 'react-notifications';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/work-report',
        breadcrumbName: 'Báo cáo',
    },
]

class WorkReportList extends Component {
    state = {
        isLoading: false,
        selectedRowKeys: [],
        isOpenForm: false,
        currentData: null,
        isOpenDetail: false,
        current_id: null,
        isLoadingExport: false
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getAllData(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.getAllData(query).then(() => {
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        query = cleanObject(query);

        this.props.history.push({
            pathname: '/work-report',
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: '/work-report',
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenForm(isOpenForm, data = null) {
        this.setState({ isOpenForm: isOpenForm, currentData: data });
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getData(id).then(res => {
            this.toggleOpenDetail(true, res);
        })
    }

    onRemove() {
        this.props.removeData(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }

    reloadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.getAllData(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    startExcelExport() {
        const { authUser } = this.props;

        const query = qs.parse(this.props.location.search.slice(1));

        this.setState({ isLoadingExport: true });

        // Gọi API exportExcel, nhưng không chờ response
        this.props.exportExcel(query).catch(() => {
            NotificationManager.error(
                "Có lỗi xảy ra trong quá trình gửi yêu cầu xuất file. Vui lòng thử lại sau.",
                "Lỗi",
                9000
            );
        }).finally(() => {
            this.setState({ isLoadingExport: false });
        });

        this.setState({ isLoadingExport: false });
        // Thông báo ngay lập tức cho người dùng
        NotificationManager.success(
            `Quá trình xuất file đang được thực hiện. 
            File kết quả sẽ được gửi vào email ${authUser.email} trong ít phút.`,
            "Thông báo",
            9000
        );
    }

    render() {
        var { data_list, pagination, users, authUser } = this.props;
        var {
            isLoading,
            selectedRowKeys,
            isOpenForm,
            currentData,
            isOpenDetail,
            current_id,
            isLoadingExport
        } = this.state;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                width: '50px'
            },
            {
                title: 'Người báo cáo',
                dataIndex: 'user',
                key: 'user',
                width: '200px',
                render: (text, record) => {
                    if (checkPermission('work_report', 'detail')) {
                        return (
                            <Tooltip title="Xem chi tiết" placement="right">
                                <div className='color-primary item-action-btn' onClick={() => this.onDetail(record.id)}>
                                    <Avatar
                                        style={{
                                            backgroundColor: '#31cdf5',
                                            verticalAlign: 'middle'
                                        }}
                                        size="small">
                                        {record.user ? getFirstLetterOfWords(record.user) : ''}
                                    </Avatar>
                                    &nbsp;{text}
                                </div>
                            </Tooltip>
                        )
                    } else {
                        return (
                            <>{text}</>
                        )
                    }
                }
            },
            {
                title: 'Nội dung báo cáo',
                dataIndex: 'content',
                key: 'content',
                width: '250px',
                render: (text, record) => {
                    return (
                        <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                    )
                }
            },
            {
                title: 'Ngày báo cáo',
                dataIndex: 'report_date',
                key: 'report_date',
                sorter: true,
                width: '140px',
                render: (text, record) => {
                    return (<div>{isValidDate(text, false)}</div>)
                }
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <Tooltip title={ReactHtmlParser(text)}>
                            <div style={{ wordBreak: "break-word" }}>
                                <TextTruncate line={1} truncateText="…" text={stripHtml(text)} />
                            </div>
                        </Tooltip>
                    )
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                sorter: true,
                width: '140px',
                render: (text, record) => {
                    return (<div>{isValidDate(text, true)}</div>)
                }
            },
        ];
        var filters = [
            <DatePicker
                format="DD/MM/YYYY"
                className="w-100"
                placeholder="Ngày bắt đầu"
                onChange={(value) => this.onChangeFilter("start_date", value ? moment(value).format('YYYY-MM-DD') : null)}
                defaultValue={query.start_date ? moment(query.start_date, 'YYYY-MM-DD') : null} />,
            <DatePicker
                format="DD/MM/YYYY"
                className="w-100"
                placeholder="Ngày kết thúc"
                onChange={(value) => this.onChangeFilter("end_date", value ? moment(value).format('YYYY-MM-DD') : null)}
                defaultValue={query.end_date ? moment(query.end_date, 'YYYY-MM-DD') : null} />
        ];

        const allowedRoles = ['ADMIN', 'KETOAN'];
        if (allowedRoles.includes(authUser.role_code)) {
            filters.push(
                <BaseSelect
                    options={users}
                    optionValue="user_id"
                    optionLabel="display_name"
                    placeholder="Người báo cáo"
                    showSearch={false}
                    className="w-100"
                    defaultValue={parseInt(query.user_id) || null}
                    onChange={(value) => this.onChangeFilter("created_user_id", value)}
                />
            );
        }


        return (
            <div>
                <PageTitle routes={routes} title="Báo cáo" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('work_report', 'create')}
                        isShowDeleteButton={checkPermission('work_report', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.type}
                        filters={filters}
                    >
                        {
                            checkPermission('work_report', 'export') ? (
                                <Button className="table-button" loading={isLoadingExport} type='default' onClick={() => this.startExcelExport()} icon={<ExportOutlined />}>Export</Button>
                            ) : null
                        }
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.reloadData()}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                <Table
                    rowKey="id"
                    size="small"
                    dataSource={data_list}
                    columns={columns}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
                <WorkReportForm
                    visible={isOpenForm}
                    reloadData={() => this.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <Detail
                    visible={isOpenDetail}
                    currentData={currentData}
                    reloadList={() => this.reloadData()}
                    reloadData={() => this.onDetail(current_id)}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    //console.log("state: ",state.WorkReportReducer.data_list)
    return {
        data_list: state.WorkReportReducer.data_list,
        pagination: state.WorkReportReducer.pagination,
        users: state.config.users,
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAllData: (filter) => dispatch(getAllData(filter)),
        getData: (id) => dispatch(getData(id)),
        removeData: (ids) => dispatch(removeData(ids)),
        exportExcel: (filter) => dispatch(exportExcel(filter)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkReportList);
